<template>
    <div>
        <img
            alt="Ideasfundx logo"
            src="../../../../assets/img/m-3.png"
            class=""
        />

        <div class="mt-3">
            <v-row class="mb-n8">
                <v-col cols="12" sm="10" md="10" lg="4">
                    <p class="text-sm-left mt-2 font-weight-light text-black">Primary product/service the offer</p>
                </v-col>
                <v-col class="m-0 pl-0" cols="12" sm="10" md="10" lg="6">
                    <v-select
                        disabled
                        v-model="product.service_offer"
                        class="text-bold"
                        :items="allPrimary"
                        outlined
                        dense
                        style="margin-left: 6px;"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                    <p class="text-sm-left mt-2 font-weight-light text-black">Technology focus</p>
                </v-col>

                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="product.technology_focus ? 'primary' : ''">
                        YES
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="no_technology_focus ? 'primary' : ''">
                        NO
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                    <p class="text-sm-left font-weight-light text-black">With R&D</p>
                </v-col>

                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="product.rd ? 'primary' : ''">
                        YES
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="no_rd ? 'primary' : ''">
                        NO
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                    <p class="text-sm-left font-weight-light text-black">Exclusive proprietary rights or patents</p>
                </v-col>

                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="product.exclusive_technology ? 'primary' : ''">
                        YES
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="no_exclusive_technology ? 'primary' : ''">
                        NO
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
    import BusinessService from "@/store/services/business.service";
    import Var from "@/store/services/var";

    export default {
        props: {
            company_id: Number,
        },
        components : {},
        data() {
            return {
                allPrimary: [],
                product: {},
                no_technology_focus: false,
                no_exclusive_technology: false,
                no_rd: false,
            }
        },

        mounted () {
            Var.getAllTypeOfOffers().then((res) => { this.allPrimary = res.data; })

            BusinessService.getProduct(this.company_id).then((res) => {
                this.product = res.data;
            })
        }
    }
</script>